// extracted by mini-css-extract-plugin
module.exports = {"Item":"Item-module--Item--2hp3R"};